import { jsx as e } from "react/jsx-runtime";
import { c as t } from "../index-Cu0xwYjD.js";
import * as m from "react";
import { C as f } from "../Card-Cf3w06Qm.js";
const l = "_cardSection_wx6kf_1", _ = "_sectioned_wx6kf_5", S = "_divider_wx6kf_9", c = {
  cardSection: l,
  sectioned: _,
  divider: S
}, p = m.forwardRef(
  ({ children: r, className: i, ...o }, s) => {
    const a = t(c.card, c.sectioned, i);
    return /* @__PURE__ */ e(f, { ...o, className: a, ref: s, children: r.flatMap((d, n) => [/* @__PURE__ */ e(v, {}, n), d]).slice(1) });
  }
);
p.displayName = "CardSectioned";
const u = ({
  children: r,
  className: i
}) => /* @__PURE__ */ e("div", { className: t(c.cardSection, i), children: r });
function v() {
  return /* @__PURE__ */ e("hr", { className: c.divider });
}
export {
  u as CardSection,
  p as CardSectioned
};
